import { CardContainer } from "@msys/ui";
import { Stack } from "@mui/material";
import { useTranslate } from "@tolgee/react";
import { useNavigate } from "react-router-dom";
import { SupplierProductAlternativePicker } from "../SupplierProductAlternativePicker.js";
import { RestrictedByOrganisationPermissionWithDebug } from "../../../auth/RestrictedByOrganisationPermission.js";

export function ProductOverviewAlternativePickerBox({
  product,
  productAlternatives,
}: Pick<
  React.ComponentProps<typeof SupplierProductAlternativePicker>,
  "product" | "productAlternatives"
>) {
  const navigate = useNavigate();

  const { t } = useTranslate(["ProductOverview"]);

  return (
    <CardContainer
      title={t("Product alternatives", {
        ns: "ProductOverview",
      })}
    >
      <Stack
        spacing={1}
        direction="column"
        sx={{
          p: 1,
        }}
      >
        <RestrictedByOrganisationPermissionWithDebug permission="pim_catalogue_update">
          <SupplierProductAlternativePicker
            product={product}
            productAlternatives={productAlternatives}
            onProductSelect={product =>
              navigate(
                `/products/catalogues/supplier/${
                  product.supplierId
                }/${encodeURIComponent(product.articleNumber)}/overview`
              )
            }
          />
        </RestrictedByOrganisationPermissionWithDebug>
      </Stack>
    </CardContainer>
  );
}
